module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$route.path === '/matches' || _vm.$route.path === '/favourites') ? _c('div', {
    staticClass: "col-3"
  }, [_c('router-link', {
    staticClass: "profile-box",
    attrs: {
      "to": 'user/' + _vm.userData.slug
    }
  }, [_c('div', {
    staticClass: "image-profile"
  }, [_c('img', {
    attrs: {
      "src": _vm.userData.profileimg
    }
  }), _vm._v(" "), (_vm.metadisplay) ? _c('div', {
    staticClass: "btn-remove",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.removeFavourite(_vm.userid)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$route.path === '/matches') ? _c('div', {
    staticClass: "btn-remove",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.removeMatch(_vm.userid)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "info",
    attrs: {
      "data-userid": _vm.userid
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.userData.firstname + ' ' + _vm.userData.surname))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.userData.jobtitle) + ", " + _vm._s(_vm.userData.organisation))]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_vm._v("Based in " + _vm._s(_vm.userData.location))])])])], 1) : (_vm.$route.path === '/everyone') ? _c('div', {
    staticClass: "col-2"
  }, [_c('router-link', {
    staticClass: "profile-box small",
    attrs: {
      "to": 'user/' + _vm.userData.slug
    }
  }, [_c('div', {
    staticClass: "image-profile"
  }, [_c('img', {
    attrs: {
      "src": _vm.userData.profileimg
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info",
    attrs: {
      "data-userid": _vm.userid
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.userData.firstname + ' ' + _vm.userData.surname))]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.userData.jobtitle) + ", " + _vm._s(_vm.userData.organisation))])])])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35ecd5c4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserBox.vue
// module id = 703
// module chunks = 1